import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/user";
import previousScoreBoxReducer from './reducers/previousScoreBoxSlice';
import fetchStoriesReducer from "./reducers/topStoriesSlice";
import fetchGamesReducer  from "./reducers/upcomingLakersGameSlice";
import fetchTwitterLinkReducer from "./reducers/getTwitterLinkSlice";
import  fetchCommunityReducer from "./reducers/getCommnunitySlice";
import  fetchFullStoriesReducer  from "./reducers/getStoryDetailsSlice";
import  fetchCommunitySectionReducer from "./reducers/getWelcomeCommunitySlice";
import updateWelcomeCommunityReducer from "./reducers/updateWelcomeCommunity";
import deleteTwitterAccountReducer from "./reducers/deteteTwitterAccount";
// import signUpEventsReducer from "./reducers/signupNewsletter";
import signupEventsReducer from "./reducers/signupEventsSlice";
import signUpNewsLetterReducer  from "./reducers/newsLetterSlice";

export const store = configureStore({
  reducer: {
    userStore: userReducer,
    previousScore:previousScoreBoxReducer,
    fetchStories:fetchStoriesReducer,
    fetchGames:fetchGamesReducer,
    fetchTwitterLink:fetchTwitterLinkReducer,
    fetchCommunitySection:fetchCommunityReducer,
    fetchFullStories:fetchFullStoriesReducer,
    fetchCommunityById:fetchCommunitySectionReducer,
    updateWelcomeCommunity:updateWelcomeCommunityReducer,
    deleteTwitterAccount:deleteTwitterAccountReducer,
    signUpEvents: signupEventsReducer,
    signUpNewsLetter: signUpNewsLetterReducer,
  },
});
